import React, {Component} from 'react';
import {Col, Row, Tabs, Tab, FormControl} from 'react-bootstrap';
import config from  '../../../../config';
import json2csv   from 'json2csv'
import moment   from 'moment'
import Select   from 'react-select'
import {} from "actions/actionTypes";
import formatNumbers  from 'util/formatNumbers';
import {prepareSelectOptionsList, filterFocusAreaOptions,convertToHoursAndMinutes,  filterFocusAreaSelectedOptions} from 'util/Utils';

const allReportFieldList = [
    {label: 'First name', value: 'firstName'},
    {label: 'Last name', value: 'lastName'},
    {label: 'Email', value: 'email'},
    {label: 'Location', value:'MarketName'},
    {label: 'Date range', value: 'DateRange'},
    {label: 'Description', value: 'Description'},
    {label: 'Worker Type', value: 'ContractorID.Type'},
    {label: 'Payment Method', value: 'ContractorID.PaymentMethod'},
    {label: 'Pay rate', value: 'HourlyRate'},
    {label: 'Payment', value: 'Payment'},

    {label: 'Hours', value: 'Hours'},
     {label: 'Requested At', value: 'RequestedAt'},
    {label: 'Paid At', value: 'PaidAt'},
    {label: 'Status', value: 'Status'},
    {label: 'Comment', value: 'Comment'},
 ]
var actionsList = [
    {'label':'Delete transactions', value:'DeleteTransactions'},
]
export default class ContractorTransactionsActionsBox extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props, context) {
        super(props, context);


        this.state = {
            pending: false,
            BulkActionNote:'',
            selectedAction:'',
            displayTabs:{},
            reportFields: allReportFieldList
         };

    };


    downloadReport() {
        var methodData = {
            "endpoint": "/create-report",
            'type': 'post',
            'not_display_success_message': true,
            overrideServerBaseURL: config.getEnvironment().directServerBaseURL,
        };
        this.props.makeRequest({
            'recordIDs': this.props.adminTransactions.selectedTransactions,
            reportType: 'timeTrackingTransactions',
         }, methodData).then(res => {
            var fields = _.map(this.state.reportFields, function (field) {
                return _.extend({}, field, {default: ''});
            })

             var dataToExport  = []
            _.forEach(res.data, function (record) {


                var customData = {
                    'firstName':_.get(record, 'UserID.firstName','n/a'),
                    'lastName':_.get(record, 'UserID.lastName','n/a'),
                    'email':_.get(record, 'UserID.email','n/a'),
                    createdAt:moment( record.createdAt).format("YYYY-MM-DD HH:mm:ss"),
                    updatedAt:moment( record.updatedAt).format("YYYY-MM-DD HH:mm:ss"),

                    Payment:formatNumbers.formatMoney(_.get(record, 'Amount')),
                    Status: _.startCase(record.Status),
                    Hours:_.get(record,['CustomData', 'TotalTimeLogsDuration']) ? convertToHoursAndMinutes(moment.duration(_.get(record,['CustomData', 'TotalTimeLogsDuration'])), {format: 'minutes_in_percentage'}) : '',

                    RequestedAt:_.get(record,['CustomData', 'PayoutRequestDate']) ?  moment(record.CustomData.PayoutRequestDate).format('MM/DD') : 'N/A',
                    DateRange: _.get(record,['CustomData', 'TimeLogsStartTime']) ?  moment(_.get(record,['CustomData', 'TimeLogsStartTime'])).format('MM/DD') + ' - ' + moment(_.get(record,['CustomData', 'TimeLogsEndTime'])).format('MM/DD') : ''
,
                };
                dataToExport.push({...record,...customData})
                if (_.size(record.WorkingTimeRecords)){
                    _.forEach(record.WorkingTimeRecords, function (timeLogRecord) {
                        var timeLogDuration = moment.duration(moment(timeLogRecord.EndTime).diff(moment(timeLogRecord.StartTime),'miliseconds'))
                        var totalPayment = _.get(timeLogRecord, 'HourlyRate',0) * Math.floor(timeLogDuration.asHours())
                        var minutesPercent = timeLogDuration.minutes() / 60 * 100;
                          var paymentForMinutes = _.get(timeLogRecord, 'HourlyRate',0) / 100 * minutesPercent
                         totalPayment += paymentForMinutes
                        var timeLogRecordCustomData = {
                            createdAt:moment( timeLogRecord.createdAt).format("YYYY-MM-DD HH:mm:ss"),
                            Status: _.startCase(timeLogRecord.Status),
                            HourlyRate: _.get(timeLogRecord, 'HourlyRate',''),
                            Payment:formatNumbers.toFixed(totalPayment,2),
                            Description: _.startCase(timeLogRecord.ActivityType),
                            Comment: _.get(timeLogRecord, 'Comment'),
                            Hours:convertToHoursAndMinutes(timeLogDuration, {format: 'minutes_in_percentage'}),
                         };
                        dataToExport.push(timeLogRecordCustomData)
                    })
                }
            })
            console.log('dataToExport', dataToExport  );
            var csvData = json2csv.parse(dataToExport, {
                fields: fields,
            })

            var filename = "time_tracking_transactions_report" + moment().format("YYYY-MM-DD-HH-mm") + ".csv";
            var blob = new Blob([csvData], {type: 'text/csv;charset=utf-8;'});
            if (navigator.msSaveBlob) { // IE 10+
                navigator.msSaveBlob(blob, filename);
            } else {
                var link = document.createElement("a");
                if (link.download !== undefined) { // feature detection
                    // Browsers that support HTML5 download attribute
                    var url = URL.createObjectURL(blob);
                    link.setAttribute("href", url);
                    link.setAttribute("download", filename);
                    link.style.visibility = 'hidden';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            }

        }).catch(err => {
            console.log('err', err);
        });
    }
    onSelectTab(event){
        this.setState({displayTabs:{...this.state.displayTabs,[event]:!this.state.displayTabs[event]}})
    }
    triggerSelectedAction(){
        var methodData = {
            "endpoint": "/transactions-process-action",
            'type':'post',
        };


        var self = this;
        self.setState({   pending:true })
        this.props.makeRequest({'action':self.state.selectedAction, 'Note':this.state.BulkActionNote, 'recordIDs':this.props.adminTransactions.selectedTransactions  }, methodData).then(response => {
            self.setState({  pending:false })
            this.props.search()
            if (_.get(response, ['data', 'clientMessage'], '')){
                this.props.displayMessage({
                    'messageCode':_.get(response, ['data', 'clientMessage'], '')
                });
            } else{
                return this.props.displayMessage({
                    'messageCode':'Action processed'
                });
            }

        }).catch(error => {
            console.log('error', error );
            self.setState({  pending:false })
        });
    }


    render() {
        return (
            <div className="transaction-action-block top20">
                <Tabs defaultActiveKey={'reports'}  onSelect={(e)=>{this.onSelectTab(e)}} id="userActionBox" >
                    <Tab eventKey={'reports'} unmountOnExit={true} title="Reports"
                      className= {_.get(this.state.displayTabs,['reports'], false) ? '':'hidden'}>
                    <Row className="show-grid">
                        <Col md={4} xs={4} className="top10">
                            <Select
                                tabIndex="0"
                                searchable={true}
                                multi
                                selectedOptions
                                clearable={false}
                                placeholder="Included fields"
                                options={allReportFieldList}
                                onChange={ (selectedOptions) => this.setState({reportFields: selectedOptions})}
                                //  filterOptions={filterOptions}
                                value={this.state.reportFields}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={3} xs={6} className="top10">
                            <button className="btn btn-primary" disabled={this.state.pending}
                                    onClick={ this.downloadReport.bind(this)}
                                    type="button">
                                Download report
                            </button>
                        </Col>
                    </Row>
                    </Tab>
                    {_.size(_.intersection(_.get(this.props, 'userReducer.user.Roles', []), ['Administrator'])) > 0 &&
                    <Tab eventKey={'actions'}
                         className={_.get(this.state.displayTabs, ['actions'], false) ? '' : 'hidden'}
                         unmountOnExit={true} title="Actions">
                        <Row className="show-grid">


                            <Col lg={3} md={4} xs={6} className="top10">
                                <Select
                                    tabIndex="0"
                                    clearable={true}
                                    placeholder="Action"
                                    options={actionsList}
                                    onChange={(option) => {
                                        this.setState({
                                            selectedAction: option ? option.value : null,
                                        })
                                    }}
                                    value={this.state.selectedAction}
                                />
                            </Col>
                            { this.state.selectedAction == 'DeleteTransactions' &&
                            <Col lg={3} md={4} xs={6} className="top10">
                                <FormControl type="text"
                                             defaultValue={this.state.BulkActionNote}
                                             onChange={ (event) => this.setState({BulkActionNote: event.target.value})}
                                             placeholder="Note for action"/>
                            </Col>
                            }

                            <Col md={3} xs={3} className="top10">
                                <button className="btn btn-primary bg-red border-red"
                                        onClick={this.triggerSelectedAction.bind(this)}
                                        disabled={!this.state.selectedAction || this.state.pending}
                                        type="button">
                                    Run action
                                </button>
                            </Col>
                        </Row>
                    </Tab>
                    }
                </Tabs>
            </div>
        );

    }
}



